export default __webpack_public_path__ + "a93cb4024f0041f2a6f5ce2bfdaa3094.png";